// extracted by mini-css-extract-plugin
module.exports = {"user":"HeaderUser_user__gCYKi","nameText":"HeaderUser_nameText__zdvJ7","icon":"HeaderUser_icon__hcu45","iconUser":"HeaderUser_iconUser__eorhN","text":"HeaderUser_text__4KIaK"};